import {withButton} from '../Button';
import {styled} from '../../styled-components';
import Button from '../Button';
import {smooth} from '../../mixins/smooth';

// TODO: WIP: NOT READY TO BE USED
export const ButtonPrimary = styled(Button.StyledComponent)`
    ${smooth('background')};
    background-color: ${props => props.theme.color.accent.main};
    color: ${props => props.theme.color.text};
    padding: ${props => `${props.theme.spacing.units(2)} ${props.theme.spacing.units(4)}`};

    &:hover {
        background-color: ${props => props.theme.color.accent.light};
    }
`;

ButtonPrimary.displayName = 'ButtonPrimary';

export default withButton(ButtonPrimary);
